<template>
    <div class="d-flex flex-wrap flex-stack my-5">
        <router-link to="/module" class="btn btn-primary align-self-center">
            <span class="svg-icon svg-icon-2">
                <inline-svg src="/media/icons/duotune/arrows/arr021.svg" />
            </span>
            {{ $t("menu.modules") }}
        </router-link>
    </div>
    <custom-table
        :title="$t('pages.module.studentSuccess.title')"
        :subTitle="$t('pages.module.studentSuccess.subTitle')"
        selectableRows
        rowKey="id"
        :items="table.data"
        :loading="table.loading"
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        @action="handleClickAction"
        @selectableRows="handleSelectedRow"
        @changeTable="handleTableChange">
        <template v-slot:firstname="{ row: record }">
            {{ record.firstname }} {{ record.lastname }}
        </template>
        <template v-slot:university="{ row: record }">
            {{ record.options.areas.university }}
        </template>
        <template v-slot:department="{ row: record }">
            {{ record.options.areas.department }}
        </template>
        <template v-slot:exam_name="{ row: record }">
            {{ record.options.areas.exam_name }}
        </template>
        <template v-slot:ranked="{ row: record }">
            {{ record.options.areas.ranked }}
        </template>
        <template v-slot:status="{ row: record }">
            <span :class="record.active ? 'badge-light-success': 'badge-light-danger'" class="badge">{{ record.active ? $t('common.active') : $t('common.passive') }}</span>
        </template>
        <template v-slot:createdAt="{ row: record }">
            {{ $moment(record.created_at).format("DD.MM.YYYY - HH:mm:ss") }}
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <router-link :to="'/module/student-success/save/' + record.id" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                     <span class="svg-icon svg-icon-3">
                         <inline-svg src="/media/icons/duotune/art/art005.svg" />
                     </span>
                </router-link>
                <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteRecord([record.id])">
                    <template #reference>
                        <a class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                            <span class="svg-icon svg-icon-3">
                                <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                            </span>
                        </a>
                    </template>
                </el-popconfirm>
            </div>
        </template>
    </custom-table>
</template>

<script>
import CustomTable from "@/components/custom-table";

export default {
    name: "index",
    components: {
        CustomTable
    },
    data(){
        return {
            fields: [
                {
                    name: this.$t("pages.module.studentSuccess.cols.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.module.studentSuccess.cols.firstname"),
                    scopedSlots: {customRender: "firstname"}
                },
                {
                    name: this.$t("pages.module.studentSuccess.cols.university"),
                    scopedSlots: {customRender: "university"}
                },
                {
                    name: this.$t("pages.module.studentSuccess.cols.department"),
                    scopedSlots: {customRender: "department"}
                },
                {
                    name: this.$t("pages.module.studentSuccess.cols.exam_name"),
                    scopedSlots: {customRender: "exam_name"}
                },
                {
                    name: this.$t("pages.module.studentSuccess.cols.ranked"),
                    scopedSlots: {customRender: "ranked"}
                },
                {
                    name: this.$t("common.sort"),
                    key: "sort",
                    class: ""
                },
                {
                    name: this.$t("common.status"),
                    scopedSlots: {customRender: "status"}
                },
                {
                    name: this.$t("common.createdAt"),
                    scopedSlots: {customRender: "createdAt"}
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "new",
                    icon: "bi-plus-lg",
                    label: "btn.add"
                },
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                },
                {
                    name: "delete",
                    icon: "bi-trash",
                    label: "btn.delete"
                }
            ],
            selectedRowKeys: []
        }
    },
    computed: {
        table() {
            return this.$store.state.module.studentSuccess.table;
        }
    },
    mounted(){
        this.setCurrentPageBreadcrumbs(this.$t("pages.module.studentSuccess.title"), [this.$t("menu.moduleManagement")]);
        this.$store.dispatch('module/studentSuccess/get', {page: {}});
    },
    methods:{
        deleteRecord(id){
            this.$store.dispatch("module/studentSuccess/delete", {
                id: id
            }).then((successDeleted) => {
                this.selectedRowKeys = this.selectedRowKeys.filter(x => !successDeleted.includes(x));
            });
        },
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                case "new":
                    this.$router.push({
                        path: "/module/student-success/save"
                    });
                    break;

                case "delete":
                    this.deleteRecord(this.selectedRowKeys.flat());
                    break;

                default:
                    break;
            }
        },
        refreshTable(){
            this.$store.dispatch("module/studentSuccess/refresh");
        },
        handleTableChange(pagination, filterData) {
            this.$store.dispatch("module/studentSuccess/get", {
                page: pagination,
                filterData: filterData
            });
        },
        handleSelectedRow(record){
            this.selectedRowKeys = record;
        }
    }
}
</script>

<style scoped>

</style>